import { createAction, props } from '@ngrx/store';

// Initiate psy testing generation
export const generatePsyTest = createAction(
  '[Psy Testing] Generate Psy Test',
  props<{ userId: number, testTypeId: number }>()
);

// Psy testing generation success
export const generatePsyTestSuccess = createAction(
  '[Psy Testing] Generate Psy Test Success',
  props<{ result: any }>()
);

// Psy testing generation failure
export const generatePsyTestFailure = createAction(
  '[Psy Testing] Generate Psy Test Failure',
  props<{ error: any }>()
);

// Save answers action
export const savePsyTestAnswers = createAction(
  '[Psy Testing] Save Psy Test Answers',
  props<{ code: string, answers: { [itemId: number]: number } }>()
);

// Save answers success
export const savePsyTestAnswersSuccess = createAction(
  '[Psy Testing] Save Psy Test Answers Success',
  props<{ result: any }>()
);

// Save answers failure
export const savePsyTestAnswersFailure = createAction(
  '[Psy Testing] Save Psy Test Answers Failure',
  props<{ error: any }>()
);

// Fetch psy testing report based on code
export const fetchPsyTestReport = createAction(
  '[Psy Testing] Fetch Psy Test Report',
  props<{ code: string }>()
);

// Success and failure actions
export const fetchPsyTestReportSuccess = createAction(
  '[Psy Testing] Fetch Psy Test Report Success',
  props<{ report: any }>()
);

export const fetchPsyTestReportFailure = createAction(
  '[Psy Testing] Fetch Psy Test Report Failure',
  props<{ error: any }>()
);
